module.exports = __webpack_public_path__ + "bear-d33e8a4237f2f79836cb39e1d6fef295.png";